import { render, staticRenderFns } from "./CorporationTax.vue?vue&type=template&id=0e6891cc&scoped=true&"
import script from "./CorporationTax.vue?vue&type=script&lang=js&"
export * from "./CorporationTax.vue?vue&type=script&lang=js&"
import style0 from "./CorporationTax.vue?vue&type=style&index=0&id=0e6891cc&prod&lang=scss&"
import style1 from "./CorporationTax.vue?vue&type=style&index=1&id=0e6891cc&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e6891cc",
  null
  
)

export default component.exports